import React from "react";
import * as S from "./styled";
import TinySlider from "_c/modules/profile/common/tiny-slider/index";
import { generateAvatar } from "@/utils";
import isempty from "lodash/isEmpty";
import PT from "prop-types";
import Info from "_c/atoms/Info";
import { useHistory } from "react-router-dom";
import { LinkGenerator } from "@/utils/LinkGenerator";
import { SALOON_NS as ns } from "@/i18n/ns";

const SaloonMasters = ({ t, ...props }) => {
  const history = useHistory();
  const onMasterAdd = () => {
    history.push("/salon/dashboard/employees");
  };
  return (
    <S.ListSect>
      <S.Title>{t(`${ns}:aside.masters_head`)}</S.Title>
      {isempty(props.masters) ? (
        <Info>
          {props.isOwner ? (
            <>
              <button onClick={onMasterAdd}>
                {t(`${ns}:aside.masters_empty_owner.1`)}
              </button>{" "}
              <span>{t(`${ns}:aside.masters_empty_owner.2`)}</span>
            </>
          ) : (
            <span>{t(`${ns}:aside.masters_empty`)}</span>
          )}
        </Info>
      ) : (
        <TinySlider
          data={props.masters.map(({ _id, user }) => ({
            title: user.first_name,
            id: _id,
            avatar: generateAvatar({ url: user.avatar, sex: user.sex }),
            url: LinkGenerator.masterProfile(_id),
          }))}
        />
      )}
    </S.ListSect>
  );
};
SaloonMasters.propTypes = {
  masters: PT.array,
  isOwner: PT.bool,

  t: PT.func.isRequired,
};
export default SaloonMasters;
